export default {"src":"/_next/static/media/hhgf.a8010d1c.svg","height":53,"width":38,"blurWidth":0,"blurHeight":0};